function createAndClickLink(url) {
  const link = document.createElement('a');
  link.id = 'idlink'; 
  link.href = url; 
  document.querySelector('body').appendChild(link);
  document.getElementById('idlink').click();
}

(function (window) {
  //Redirect on success signin
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.action === 'signin') {
      window.location.replace("/#/portal/account");
  }

  // Use form for nonprofit users  
  const academicHash = '#academic';
  const academicUrl = '/acedemic-non-profit';
  const educationDomains = ['org', 'edu'];

  const signupForm = document.querySelector('#signupForm');
  if(!signupForm) return;
  const currentHash = window.location.hash;
  if (academicHash !== currentHash) {
    signupForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (params.type === 'group') {
        const link = params.link + '?' + params.subject + '&' + params.body;
        createAndClickLink(link);
      }
      if (params.type === 'paid') {
        const closeModalBtn = document.querySelector('#closeModalBtn');
        closeModalBtn.classList.add('hidden');
        if (params.value === 'monthly') {
          const monthlySubscribeButton = document.querySelector('#monthlySubscribeBtn');
          monthlySubscribeButton.classList.remove('hidden');
        } 
        if (params.value === 'yearly') {
          const yearlySubscribeButton = document.querySelector('#yearlySubscribeBtn');
          yearlySubscribeButton.classList.remove('hidden');
        }
      }

      const sussesModal = document.querySelector('#successPopup');
      if(!sussesModal) return;
      sussesModal.classList.remove('hidden');
    });
  } else {
    const signupSubmitButton = document.querySelector('#signupSubmitButton');
    const submit = signupForm.querySelector('[type=submit]');
    if(!signupSubmitButton) return;
    signupSubmitButton.classList.remove('hidden');
    submit.classList.add('hidden');

    signupSubmitButton.addEventListener('click', (e) => {
      e.preventDefault();
      const notEducationErrorMessage = document.querySelector('#emailEducationError');
      if (!notEducationErrorMessage) return;
      const emailField = document.querySelector('#input-email');
      if(!emailField) return;
      const email = emailField.value;
      const emailParts = email.split('.');
      const emailDomain = emailParts[emailParts.length-1];
      if (educationDomains.includes(emailDomain)) {
        notEducationErrorMessage.classList.add('hidden');
        const event = new Event('submit');
        signupForm.dispatchEvent(event);
        window.location.href = academicUrl;
      } else {
        notEducationErrorMessage.classList.remove('hidden');
      }
    });
  }

})(window, document);

(function (window) {
  //Tiers tabs
  const tabs = document.querySelector(".wrapper");
  const tabButton = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".content");
  if (tabs) {
    tabs.addEventListener('click', (e) => {
      const id = e.target.dataset.id;
      if (id && tabButton) {
        tabButton.forEach(btn => {
          btn.classList.remove("active");
        });
        e.target.classList.add("active");
    
        contents.forEach(content => {
          content.classList.remove("active");
        });
        const element = document.getElementById(id);
        element.classList.add("active");
      }
    })
  }
})(window, document);
